import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    aria-label=' opens in new window'
  >
    <path d='M11.376 5.623a.75.75 0 1 1 0 1.5h-7.5a.5.5 0 0 0-.5.5v12.5a.5.5 0 0 0 .5.5h12.5a.5.5 0 0 0 .5-.5v-7.5a.75.75 0 0 1 1.5 0v7.5a2 2 0 0 1-2 2h-12.5a2 2 0 0 1-2-2v-12.5a2 2 0 0 1 2-2zm10-3.75a.765.765 0 0 1 .42.13.748.748 0 0 1 .11.09l-.079-.069a.754.754 0 0 1 .299.6l-.004-.074.003.044v5.654a.75.75 0 1 1-1.5 0V4.433L9.407 15.653a.75.75 0 0 1-.976.073l-.084-.072a.75.75 0 0 1 0-1.061l11.219-11.22H15.75a.75.75 0 0 1-.743-.648L15 2.623a.75.75 0 0 1 .75-.75z' />
  </svg>
);
